import { useEffect } from "react";

type UseVideoDurationProps = {
	file?: File;
	onDuration: (duration: number) => void;
};

export function useVideoDuration({ file, onDuration }: UseVideoDurationProps) {
	useEffect(() => {
		if (!file) {
			return;
		}
		const video = document.createElement("video");
		video.ondurationchange = () => onDuration(video.duration);
		video.src = URL.createObjectURL(file);
	}, [file, onDuration]);
}
